/**
 * Guard per righe/card cliccabili (2026-07-02, Davide: "tutti i testi
 * dell'app devono essere selezionabili e copiabili").
 *
 * Con user-select:text anche dentro i button, un drag di selezione che
 * inizia e finisce sullo stesso elemento genera comunque un click al
 * mouseup: senza guard, copiare l'ID di un ordine aprirebbe il pannello.
 * I click handler delle righe chiamano questo helper e non fanno nulla se
 * l'utente stava selezionando.
 */
export function hasActiveTextSelection(): boolean {
  const selection = window.getSelection();
  return !!selection && selection.type === "Range" && selection.toString().length > 0;
}
